import Indicador from "..";

import { LBMParamFields } from "./components/LBMParamFields";
import LBMEditFields from "./components/LBMEditFields";

import reportSummary from "./reports/summary";
import reportApotamento from "./reports";
import { getTalhaoNomeDisplay, getTalhaoAreaDisplay } from "entity/Indicador/reports/talhaoDisplay";
// import LBMGraficoExtraPainel from "./components/LBMGraficoExtraPainel"
// import LBMGraficoExtraRelatorio from "./components/LBMGraficoExtraRelatorio"

export default class LBM extends Indicador {
    static get fullName() {
        return "Levantamento de Broca Manual";
    }

    static get abbrev() {
        return "LBM";
    }

    static paramFields(tipoIndicadorField = "") {
        return <LBMParamFields tipoIndicadorField={tipoIndicadorField} />;
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <LBMEditFields visita={visita} TipoClass={TipoClass} />;
    }

    // static getGraficoExtraPainel(indicadorProps, nomeAgrupador) {
    //     return <LBMGraficoExtraPainel indicadorProps={indicadorProps} nomeAgrupador={nomeAgrupador} />
    // }

    // static getGraficoExtraRelatorio(content, h, mediaAgrupadorList, metaUsar, IndicadorEntity, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim) {
    //     return LBMGraficoExtraRelatorio(content, h, mediaAgrupadorList, metaUsar, IndicadorEntity, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim)
    // }

    async renderReport(visita) {
        return reportApotamento(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return reportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (
            !apontamento.coletas ||
            !params ||
            apontamento.coletas.length === 0 ||
            apontamento.coletas.filter((c) => c.numBrocas && c.numCanas).length === 0
        ) {
            return 0;
        }

        const totalNumColetas = apontamento.coletas.length;
        let totalBrocas = 0;
        let totalCanas = 0;
        let totalBrocasInternas = 0;

        for (const coleta of apontamento.coletas) {
            if (coleta.numBrocas) {
                totalBrocas = totalBrocas + f(coleta.numBrocas);
            }
            if (coleta.numCanas) {
                totalCanas = totalCanas + f(coleta.numCanas);
            }
            if (coleta.brocasInternas) {
                totalBrocasInternas = totalBrocasInternas + f(coleta.brocasInternas);
            }
        }
        apontamento.totalBrocas = totalBrocas;
        apontamento.totalCanas = totalCanas || totalBrocas;
        apontamento.qtPontosAvaliados = totalNumColetas;

        apontamento.totalBrocasInternas = totalBrocasInternas;
        apontamento.percentBrocasInternas = ((f(totalBrocasInternas) / f(totalCanas)) * 100).toFixed(2);

        return ((f(totalBrocas) / f(totalCanas)) * 100).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        if (conformidade <= parseFloat(meta)) {
            return "Bom";
        } else {
            return "Ruim";
        }
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        // pdf da tela de relatórios
        return [
            { title: "Data", width: "auto", getValue: (a) => a.dataRef.split("-").reverse().join("/") },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: "auto" },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },
            {
                title: "Talhão",
                field: "talhao.nome",
                getValue: (a) => getTalhaoNomeDisplay(a),
            },
            {
                title: "Área (ha)",
                field: "talhao.area",
                getValue: (a) => getTalhaoAreaDisplay(a),
            },
            { title: "Variedade", field: "variedade.variedade", width: "auto" },

            { title: "Total Brocas Encontradas", width: "auto", field: "totalBrocas" },
            { title: "Total Canas Avaliadas", width: "auto", field: "totalCanas" },
            { title: "Pontos Aval.", width: "auto", field: "qtPontosAvaliados" },

            {
                title: "Brocas Internas",
                field: "totalBrocasInternas",
                width: 55,
                getColor: (a) => {
                    // console.log('a', a)
                    return IndicadorClass.getColorStatus(
                        IndicadorClass.getConformidadeStatus(a.totalBrocasInternas, paramsCliente?.metaBrocasInternas),
                    );
                },
            },

            {
                title: "% Brocas",
                field: "conformidade",
                width: 55,
                getColor: (a) => {
                    return IndicadorClass.getColorStatus(
                        IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta),
                    );
                },
            },
        ];
    }

    static getResultStr(apontamento) {
        return (
            "Total Brocas Encontradas: " +
            apontamento.totalBrocas +
            ", Total Brocas Internas: " +
            apontamento.totalBrocasInternas +
            ", Total Canas Avaliadas: " +
            apontamento.totalCanas +
            " e Pontos Avaliados: " +
            apontamento.qtPontosAvaliados
        );
    }
}
